import fb from '@/firebaseConfig';
import analytics from '@/utils/Analytics';
import { sortByTitle } from '@/helpers/contentHelpers';

// For non-subscribers, premium cards will not show in favorites list
// So if user was a subscriber and cancels,
// they won't be stuck with favorites they can't see or remove

/*

  STATE

 */

const state = {
  favoriteIds: [],
  favoriteStackIds: [],
};

/*

  GETTERS

 */

const getters = {
  sortedFavIds: (state, getters, rootState) => {
    const { allCards } = rootState.cards;
    const unsortedIds = state.favoriteIds;
    return sortByTitle(allCards, unsortedIds);
  },

  journeyFavIds: (state, getters, rootState) => {
    const { allCards } = rootState.cards;
    return getters.sortedFavIds.filter(id => {
      const card = allCards[id] || {};
      const { category, userCanAccess } = card;
      return userCanAccess && category === 'journey';
    });
  },

  deepeningFavIds: (state, getters, rootState) => {
    const { allCards } = rootState.cards;
    return getters.sortedFavIds.filter(id => {
      const card = allCards[id] || {};
      const { category, userCanAccess } = card;
      return userCanAccess && category === 'deepening';
    });
  },

  lighteningFavIds: (state, getters, rootState) => {
    const { allCards } = rootState.cards;
    return getters.sortedFavIds.filter(id => {
      const card = allCards[id] || {};
      const { category, userCanAccess } = card;
      return userCanAccess && category === 'lightening';
    });
  },

  sortedFavStackIds: (state, getters, rootState, rootGetters) => {
    const allStacks = rootGetters['stacks/allStacks'];
    const unsortedIds = state.favoriteStackIds;
    const sortedIds = sortByTitle(allStacks, unsortedIds);
    return sortedIds.filter(id => {
      return allStacks[id] && allStacks[id].userCanAccess;
    });
  },

  indexInFavorites: (state, getters, rootState) => {
    const { currentId, routeName } = rootState.ui;
    const { sortedFavIds, sortedFavStackIds } = getters;
    if (routeName === 'Stack') {
      return sortedFavStackIds.indexOf(currentId);
    }
    return sortedFavIds.indexOf(currentId);
  },
};

/*

  ACTIONS

 */

const actions = {
  toggleFavorite({ commit, getters, rootState }) {
    const { currentId: id, routeName } = rootState.ui;
    const { uid } = rootState.user;
    const { sortedFavIds, sortedFavStackIds, indexInFavorites } = getters;
    const type = routeName === 'Stack' ? 'Stack' : '';
    let favoriteIds = [...sortedFavIds];
    if (routeName === 'Stack') {
      favoriteIds = [...sortedFavStackIds];
    }

    if (indexInFavorites === -1) {
      favoriteIds.push(id);
      analytics.saveFavorite(type === 'Stack' ? 'stack' : 'card');
    } else {
      favoriteIds.splice(indexInFavorites, 1);
      analytics.removeFavorite(type === 'Stack' ? 'stack' : 'card');
    }
    commit(`setFavorite${type}s`, favoriteIds);

    fb.usersCollection
      .doc(uid)
      .set(
        {
          [`favorite${type}Ids`]: favoriteIds,
        },
        { merge: true }
      )
      .catch(error => {
        console.error('Error writing document: ', error);
      });
  },
};

/*

  MUTATIONS

 */

const mutations = {
  setFavorites(state, favoriteIds) {
    if (favoriteIds) {
      state.favoriteIds = favoriteIds;
    }
  },

  setFavoriteStacks(state, favoriteIds) {
    if (favoriteIds) {
      state.favoriteStackIds = favoriteIds;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
